import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import _ from 'lodash'
import { Helmet } from 'react-helmet'

import {
  setActiveFilterTab,
  fetchMatches,
  fetchFilters,
} from '../../store/modules/filteredSearch.module'
import { fetchAllTools } from '../../store/modules/tools.module'
import { setActiveFilterIds } from '../../store/modules/filters.module'
import {
  ActiveFilters,
  FilteredSearchDashboard,
  LoadingIcon
} from '../../components'
import { browserUtils } from '../../utils'
import './FilteredSearch.sass'


class FilteredSearch extends Component {
  constructor() {
    super()
    this.helmet = (
      <Helmet>
        <title>Filtered Search | Gulf TREE</title>
      </Helmet>
    )
  }

  componentDidMount() {
    const {
      setActiveFilterIds,
      setActiveFilterTab,
      activeFilterIds,
      location,
      history,
      fetchFilters,
      fetchAllTools,
      matches,
      filters,
      allTools
    } = this.props

    // If a mobile (not tablet), or coming from guided search, take them directly to results page
    if (browserUtils.isMobileDevice()) {
      setActiveFilterTab(2)
    }

    // if told to skip to results section, do that then clear history state so it doesn't happen on page refresh
    if (_.get(location, ['state', 'skipToResults'])) {
      setActiveFilterTab(2)
      history.replace({ ...location, state: undefined })
    }

    // Fetch all results on page load unless there are already filters or matches set (like if we're coming from guided search)
    if (!activeFilterIds.length && !matches.exact.length) {
      setActiveFilterIds([])
    }

    // Don't have to refetch filters if they're already in redux
    if (!filters) {
      fetchFilters()
    }

    // Fetch all tools at once to populate autocomplete, but only have to do it once
    if (!allTools.data) {
      fetchAllTools()
    }
  }

  render() {
    const {
      activeTabIdx,
      matches,
      filters,
      allTools,
      activeFilterIds,
      glossary,
      isLoadingGlossary,
    } = this.props

    // Is still fetching filters
    if (!filters) {
      return (
        <div className="center-vertical-wrapper">
          {this.helmet}
          <LoadingIcon />
        </div>
      )
    }

    return (
      <section className="filtered-search" ref={el => this.container = el}>
        {this.helmet}
        <ActiveFilters
          filters={filters}
          activeFilterIds={activeFilterIds}
          setActiveFilterIds={this.props.setActiveFilterIds}
        />
        <FilteredSearchDashboard
          activeTabIdx={activeTabIdx}
          filters={filters}
          matches={matches}
          allTools={allTools.data}
          setActiveFilterTab={this.props.setActiveFilterTab}
          fetchMatches={this.props.fetchMatches}
          activeFilterIds={activeFilterIds}
          setActiveFilterIds={this.props.setActiveFilterIds}
          glossary={glossary}
          isLoadingGlossary={isLoadingGlossary}
        />
      </section>
    )
  }
}

FilteredSearch.propTypes = {
  activeTabIdx: PropTypes.number,
  matches: PropTypes.object,
  setActiveFilterTab: PropTypes.func,
  fetchMatches: PropTypes.func,
  fetchAllTools: PropTypes.func,
  filters: PropTypes.object,
  setActiveFilterIds: PropTypes.func,
  activeFilterIds: PropTypes.array,
  glossary: PropTypes.array,
  isLoadingGlossary: PropTypes.bool,
}

const mapStateToProps = state => {
  const glossary = _.get(state.content, ['data', 'glossary', 'glossary_terms'])
  let glossaryTerms = []

  // Get flat list of all glossary terms to use in the glossary autocomplete component
  if (glossary) {
    glossaryTerms = _.flatMap(glossary, glossaryLetter => glossaryLetter.terms)
  }

  return {
    activeTabIdx: state.filteredSearch.activeTabIdx,
    matches: state.filteredSearch.matches,
    filters: state.filteredSearch.filters,
    allTools: state.tools.allTools,
    activeFilterIds: state.filters.activeFilterIds,
    glossary: glossaryTerms,
    isLoadingGlossary: state.content.isLoading,
  }
}

export default connect(
  mapStateToProps,
  {
    setActiveFilterTab,
    fetchMatches,
    fetchFilters,
    fetchAllTools,
    setActiveFilterIds
  }
)(FilteredSearch)
